import Awaiting from "./Awaiting";
export default Awaiting;
